export default "__VITE_ASSET__B392DVl6__"